import React from 'react'
import laptop from '../../assets/images/laptop.svg'

const CmsView = () => {
    return (
        <div className='cms-view'><img src={laptop} alt='' /></div>
    )
}

export default CmsView
